export default __webpack_public_path__ + "static/media/9.dbb1fee4.jpg";